module.exports = __webpack_public_path__ + "static/media/liabilities.b7e170be.svg";